
    <div class="setting">
      <div>
        <div class="h7">Customers</div>
      <p class="p5">Track and manage your customer records.</p>
      </div>
      <div>
        <button class="btn btn-primary btn-medium add-location-button" (click)="openModal()"> <img src="assets/images/package/plus.svg" alt="Add Package" /> Add Customer</button>
      </div>
    </div>
    
    <!-- Customer Statistics Cards -->
    <div class="stats-container">
      <div class="stats-grid">
        <app-customer-stats-card 
          *ngFor="let stat of customerStats; trackBy: trackByIndex" 
          [data]="stat">
        </app-customer-stats-card>
      </div>
    </div>

    <!-- Customer Table -->
    <div class="table-container">
      <app-customer-table (addCustomerClick)="openModal()"></app-customer-table>
    </div>
    

<!-- Add Customer Modal -->
<app-add-customer-modal 
  [isOpen]="isModalOpen"
  (closeModal)="closeModal()"
  (customerCreated)="onCustomerCreated($event)">
</app-add-customer-modal>

